import React from 'react';
import { Link } from 'gatsby';
import BackgroundImg from 'gatsby-background-image';
import useSrcImage from '../../graphql/staticQueries/useOptimizedImage';

const IndustriesCTA = ({ text, title, extra }) => {
  const ImgCheckWhat = useSrcImage('check_what.png');
  return (
    <div className="container container-full">
      <div className="info-image">
        <div className="body">
          <div className="subtitle bigger">
            {title}
            <div
              className="extra"
              style={{ marginTop: `${title ? '' : 'unset'}` }}
            >
              {extra}
            </div>
          </div>
          <div className="content">
            <p>{text}</p>
            <div className="links">
              <Link to="/how-we-work/" className="btn btn-main">
                Our workflow
              </Link>
              <Link
                to="/software-services/#what-we-do/"
                className="btn btn-main"
              >
                What we do
              </Link>
            </div>
          </div>
        </div>
        <BackgroundImg fluid={ImgCheckWhat.fluid} className="image">
          <div className="image" />
        </BackgroundImg>
      </div>
    </div>
  );
};

export default IndustriesCTA;

IndustriesCTA.defaultProps = {
  title: 'Check what we have done',
  extra: 'and how we can help you'
};
